import { useMutation } from "react-query";
import { runScript } from "../../../../actions/Helper";
//Fetching Carrier Contact

const useRunScript = () => {
  return useMutation(runScript);
};
export default useRunScript;
